import { render, staticRenderFns } from "./OrganizationExamManagement.vue?vue&type=template&id=13c5cd33&scoped=true&"
import script from "./OrganizationExamManagement.vue?vue&type=script&lang=js&"
export * from "./OrganizationExamManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationExamManagement.vue?vue&type=style&index=0&id=13c5cd33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5cd33",
  null
  
)

export default component.exports